var map = {
	"./puzzle1.jpg": "20e1",
	"./puzzle2.jpg": "ad8f",
	"./puzzle3.jpg": "d330",
	"./puzzle4.jpg": "6a52",
	"./puzzle5.jpg": "5763",
	"./puzzle6.jpg": "208e",
	"./puzzle7.jpg": "fca2",
	"./puzzle8.jpg": "648b",
	"./puzzle9.jpg": "d8ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3941";